// eslint-disable-next-line max-classes-per-file
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { RefreshMaterializedLakeViewActivity } from 'app/model/pipeline/refresh-materialized-lake-view.activity';
import { ActivityAsyncAdapter } from '../activity.adapter';
import { IRMLVActivityContext } from 'app/interfaces/copilot.pipeline.action.types';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { linkedServiceReferenceToResource } from 'app/shared/utils/linkedservice-parameter.util';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';
import { LoggerService } from 'app/logger/logger.service';
import { LinkedService, ReferenceAdapter } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RefreshMaterializedLakeViewActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: '*'
    }
})
export class RefreshMaterializedLakeViewActivityAdapter extends 
    ActivityAsyncAdapter<RefreshMaterializedLakeViewActivity, Model.ExecutionActivity, IRMLVActivityContext> {

    protected override async _toResource(activity: RefreshMaterializedLakeViewActivity): Promise<Model.ExecutionActivity> {
        const loggerService = await getServiceInstance<LoggerService>(this.context.contextData, 'LoggerService');
        
        const modelActivity: Model.ExecutionActivity = super._getCommonActivityProperties(
            activity,
            Metamodel.modelOf(activity).name
        ) as Model.ExecutionActivity;

        //eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const typeProperties = {} as Model.RefreshMaterializedLakeViewActivityTypeProperties;
        typeProperties.lakehouseId = ValueAdapter.toResource(activity, RefreshMaterializedLakeViewActivity.LAKEHOUSEID);
        typeProperties.workspaceId = ValueAdapter.toResource(activity, RefreshMaterializedLakeViewActivity.WORKSPACEID);

        const externalReferences = linkedServiceReferenceToResource(
            activity.linkedService,
            this.context,
            loggerService
        );
        
        modelActivity.linkedServiceName = externalReferences;
        modelActivity.typeProperties = typeProperties;

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelActivity, parsed);
        }

        return modelActivity;
    }

    protected override async _toModel(modelActivity: Model.ExecutionActivity): Promise<RefreshMaterializedLakeViewActivity> {
        const metaModel = Metamodel.modelByName(modelActivity.type);
        const activity = metaModel.create<RefreshMaterializedLakeViewActivity>(modelActivity.name); 

        const typeProperties = modelActivity.typeProperties as Model.RefreshMaterializedLakeViewActivityTypeProperties;
        ValueAdapter.toModel(activity, RefreshMaterializedLakeViewActivity.LAKEHOUSEID, typeProperties.lakehouseId);
        ValueAdapter.toModel(activity, RefreshMaterializedLakeViewActivity.WORKSPACEID, typeProperties.workspaceId);

        activity.linkedService = ReferenceAdapter.toProxyModel<LinkedService>(
                            Metamodel.modelFor(LinkedService),
                            modelActivity.linkedServiceName,
                            this.context
                        );
        
        return activity;
    }

}

